import { Component, ViewEncapsulation } from '@angular/core';
import { FloatLabel } from 'primeng/floatlabel';

/**
 * Bordered form field whose label sits inside the control while it is empty and
 * moves up onto the border once the control is focused or holds a value.
 *
 * Wraps primeng's "on" float label and themes the projected primeng control
 * (pInputText, pTextarea, p-select, p-multiselect) the same way in every app, whatever
 * preset that app uses. The label goes after the control:
 *
 *   <hrra-floating-field>
 *     <input pInputText id="name" formControlName="name">
 *     <label for="name">{{ 'label.Name' | translate }}</label>
 *   </hrra-floating-field>
 */
@Component({
  selector: 'hrra-floating-field',
  templateUrl: './floating-field.component.html',
  styleUrls: ['./floating-field.component.scss'],
  imports: [FloatLabel],
  // the styles target the projected control, which emulated encapsulation can't reach
  encapsulation: ViewEncapsulation.None,
  host: { class: 'hrra-floating-field' },
})
export class FloatingFieldComponent {}
